export const SET_SELECTED_CARE_PLAN_ID = 'SET_SELECTED_CARE_PLAN_ID';
export const SET_GOAL_SUCCESS = 'SET_GOAL_SUCCESS';
export const SET_GOAL_FAIL = 'SET_GOAL_FAIL';
export const GET_PATIENT_LIST = 'GET_PATIENT_LIST';
export const GET_GROUP_LIST = 'GET_GROUP_LIST';